import { CheckCircle2, Edit, SkipForward } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

type UserAction = 'Pending' | 'Accepted' | 'Modified' | 'Rejected';

export interface ActionButtonsProps {
  onAccept: () => void;
  onModify: () => void;
  onReject: () => void;
  currentAction?: UserAction;
  disabled?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

export function ActionButtons({
  onAccept,
  onModify,
  onReject,
  currentAction = 'Pending',
  disabled = false,
  size = 'md',
  className,
}: ActionButtonsProps) {
  const buttonSize = size === 'sm' ? 'sm' : 'default';
  const iconSize = size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4';

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Button
        variant={currentAction === 'Accepted' ? 'success' : 'outline'}
        size={buttonSize}
        onClick={onAccept}
        disabled={disabled}
        className={cn(
          currentAction === 'Accepted' && 'ring-2 ring-green-500/20'
        )}
      >
        <CheckCircle2 className={cn(iconSize, 'mr-1.5')} />
        Use this answer
      </Button>
      <Button
        variant={currentAction === 'Modified' ? 'warning' : 'outline'}
        size={buttonSize}
        onClick={onModify}
        disabled={disabled}
        className={cn(
          currentAction === 'Modified' && 'ring-2 ring-amber-500/20'
        )}
      >
        <Edit className={cn(iconSize, 'mr-1.5')} />
        Edit answer
      </Button>
      <Button
        variant={currentAction === 'Rejected' ? 'destructive' : 'outline'}
        size={buttonSize}
        onClick={onReject}
        disabled={disabled}
        className={cn(
          currentAction === 'Rejected' && 'ring-2 ring-red-500/20'
        )}
      >
        <SkipForward className={cn(iconSize, 'mr-1.5')} />
        Skip
      </Button>
    </div>
  );
}
